export default "__VITE_ASSET__B49A3Gor__"